import { Link } from "react-router-dom";
import { Package, PencilLine } from "lucide-react";

export const errMsg = (e, f) => (typeof e.response?.data?.detail === "string" ? e.response.data.detail : f);
export const n = (v) => (v ?? 0).toLocaleString("en-IN");
export const money = (v) => (v == null ? "—" : `₹${Number(v).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`);
export const READY = { GREEN: ["bg-signal-green/15 text-signal-green border-signal-green/40", "READY TO SELL"], YELLOW: ["bg-signal-amber/15 text-signal-amber border-signal-amber/40", "SELL WITH CONDITIONS"], RED: ["bg-signal-red/15 text-signal-red border-signal-red/40", "NOT READY"] };
export const COMPAT = { GREEN: "bg-signal-green text-white", YELLOW: "bg-signal-amber text-black", BLUE: "bg-blue-500 text-white", RED: "bg-signal-red text-white" };
export const APP_STATUS = { approved: ["APPROVED", "text-signal-green"], technical_review: ["TECHNICAL REVIEW", "text-signal-amber"], customer_specific: ["CUSTOMER-SPECIFIC", "text-blue-400"], not_suitable: ["NOT SUITABLE", "text-signal-red"] };

export function Img({ img, size = "w-16 h-16" }) {
  return img?.url ? <img src={img.url.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${img.url}` : img.url} alt="" className={`${size} object-cover rounded-md border border-border`} /> : <div className={`${size} rounded-md border border-dashed border-border grid place-items-center text-muted-foreground`}><Package className="w-5 h-5" /></div>;
}

export function Chip({ children, cls = "" }) {
  return <span className={`inline-block px-2 py-0.5 rounded-full text-[10px] font-mono uppercase tracking-wider border ${cls}`}>{children}</span>;
}

export function HubTitle({ icon: Icon, title, subtitle, right }) {
  return (
    <div className="flex items-start justify-between gap-3 mb-1">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-2">{Icon && <Icon className="w-6 h-6 text-primary" />}{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function Badge({ ok, label }) {
  const cls = ok === true ? "hub-ok" : ok === "low" ? "hub-warn" : ok === false ? "hub-bad" : "";
  return <span className={`hub-chip ${cls}`}>{label}</span>;
}

export function StockBadge({ r }) {
  if (r.available_to_sell <= 0) return <Badge ok={false} label="Out of Stock" />;
  if (r.min_stock && r.available_to_sell < r.min_stock) return <Badge ok="low" label={`Low Stock (${n(r.available_to_sell)})`} />;
  return <Badge ok label="In Stock" />;
}

export function HubShell({ children, testid }) {
  return <div className="hub-light space-y-5" data-testid={testid}>{children}</div>;
}

export function Pencil({ onClick, testid, title = "Edit" }) {
  return <button onClick={onClick} title={title} data-testid={testid} className="ml-auto inline-flex items-center justify-center w-7 h-7 rounded-md border border-border text-muted-foreground hover:text-primary hover:border-primary/50 transition-colors"><PencilLine className="w-3.5 h-3.5" /></button>;
}

export function SkuCard({ r, selected, onSelect }) {
  const specs = [r.material, r.capacity && `${r.capacity}${r.capacity_unit || ""}`, r.neck_size].filter(Boolean);
  return (
    <div className={`bg-card border rounded-xl p-4 flex flex-col gap-2 transition-shadow hover:shadow-md ${selected ? "border-primary ring-1 ring-primary/40" : "border-border"}`} data-testid={`hub-card-${r.sku}`}>
      <div className="flex items-start justify-between"><span className="text-[11px] font-mono text-muted-foreground">SKU: {r.sku}</span>{onSelect && <input type="checkbox" className="accent-primary" checked={!!selected} onChange={() => onSelect(r.sku)} data-testid={`hub-compare-${r.sku}`} title="Compare" />}</div>
      <Link to={`/hub/sku/${encodeURIComponent(r.sku)}`} className="grid place-items-center h-36 bg-muted/40 rounded-lg" data-testid={`hub-open-${r.sku}`}><Img img={r.image} size="h-32 w-32" /></Link>
      <Link to={`/hub/sku/${encodeURIComponent(r.sku)}`} className="font-semibold text-base leading-tight hover:text-primary">{r.name}</Link>
      <p className="text-xs text-muted-foreground">{specs.join(" | ") || r.category}</p>
      <div className="flex flex-wrap gap-1">{[r.category, r.material, r.colour].filter(Boolean).map((t) => <span key={t} className="hub-chip">{t}</span>)}</div>
      <div className="flex items-center justify-between text-xs pt-1 mt-auto"><StockBadge r={r} /><span className="text-muted-foreground">Lead Time: {r.lead_time_days ? `${r.lead_time_days} days` : "—"}</span></div>
      <div className="flex items-center justify-between text-xs text-muted-foreground"><span>MOQ {r.moq ? n(r.moq) : "—"}</span><span className="metric font-semibold text-foreground">{money(r.price)}/pc</span></div>
    </div>
  );
}
